import { render, staticRenderFns } from "./ProfileGift.vue?vue&type=template&id=1c19b883&scoped=true"
import script from "./ProfileGift.vue?vue&type=script&lang=js"
export * from "./ProfileGift.vue?vue&type=script&lang=js"
import style0 from "./ProfileGift.vue?vue&type=style&index=0&id=1c19b883&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c19b883",
  null
  
)

export default component.exports